import React from 'react';
import { NavLink, useLocation } from 'react-router-dom'; // Добавили useLocation

const NavigationBar = () => {
    // Получаем текущую локацию (где мы находимся сейчас)
    const location = useLocation();

    return (
        <aside className="navigation_bar">
            <nav className="navigation_bar__container">
                <ul className="navigation_bar__list">
                    <li className="navigation_bar__item">
                        <NavLink
                            exact
                            to="/formuls"
                            className="navigation_bar__link navigation_bar__link--formuls"
                            activeClassName="active"
                        />
                    </li>
                    <li className="navigation_bar__item">
                        <NavLink
                            to="/terms"
                            className="navigation_bar__link navigation_bar__link--terms"
                            activeClassName="active"
                        />
                    </li>

                    <li className="navigation_bar__item">
                        <NavLink
                            to="/calcs"
                            className="navigation_bar__link navigation_bar__link--calcs"
                            activeClassName="active"
                        />
                    </li>
                    <li className="navigation_bar__item">
                        <NavLink
                            to="/tables"
                            className="navigation_bar__link navigation_bar__link--tables"
                            activeClassName="active"
                        />
                    </li>
                    {/* <li className="navigation_bar__item navigation_bar__item--other">
                        <NavLink
                            to="/other"
                            className="navigation_bar__link navigation_bar__link--other"
                            activeClassName="active"
                        />
                    </li> */}

                    <li className="navigation_bar__item navigation_bar__item--settings">
                        <NavLink
                            // Вместо обычной строки передаем объект с состоянием
                            to={{
                                pathname: "/settings",
                                state: { background: location } // Передаем фон!
                            }}
                            // Принудительно задаем условие активности кнопки
                            isActive={(match, location) => location.pathname === '/settings'}
                            className="navigation_bar__link navigation_bar__link--setting"
                            activeClassName="active"
                        />
                    </li>
                </ul>
            </nav>
        </aside>
    );
};

export default NavigationBar;